import styled from "styled-components";

export const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  width: 100%;
  padding-right: 10px;
  font-size: 14px;
  color: var(--text-primary);
`;

/** Scroll da página do projeto (shell do main_display tem overflow:hidden) */
export const ProjectPageScroll = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
  box-sizing: border-box;
  position: relative;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--accent, #6b8f71);
    border-radius: 10px;
  }

  /* Não adicionar padding-top aqui: o SideContainer já reserva
     espaço para o botão do menu; padding extra empurra as abas
     e faz o conteúdo aparecer acima da barra sticky. */
`;

export const ProjectBootMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  padding: 2rem 1.5rem;
  color: var(--text-secondary);
  font-size: 1rem;

  button {
    padding: 0.65rem 1.1rem;
    border-radius: 10px;
    border: 1px solid var(--border-default);
    background: var(--surface-1);
    color: var(--text-primary);
    cursor: pointer;
    font-weight: 600;

    &:hover {
      border-color: var(--accent);
    }
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;

  @media screen and (max-width: 1024px) {
    height: auto;
    min-height: 100vh;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
  }

  @media screen and (max-width: 480px) {
    padding: 10px;
  }
`;

export const SideContainer = styled.div`
  scrollbar-width: none;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  height: 100vh;
  min-height: 100vh;
  width: ${({ collapsed }) => (collapsed ? "15vw" : "6vw")};
  transition: width 0.5s ease-in-out;

  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 1024px) {
    width: ${({ collapsed }) => (collapsed ? "80vw" : "100%")};
    height: auto;
    min-height: 100vh;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    min-height: auto;
    padding: 20px;
  }
`;
